import React from "react";
import "./Interviews.css";
import rand from "random-key";
import { getAuth, setPersistence, browserLocalPersistence, onAuthStateChanged, User } from "firebase/auth";
import { getDatabase, ref, child, set, get } from "firebase/database";
import { GrAdd } from "react-icons/gr";
import { IconContext } from "react-icons";
import { Link } from 'react-router-dom';
import { InterviewsPageProps, InterviewsPageState, InterviewSessionData } from "../../types";

export default class InterviewsPage extends React.Component<InterviewsPageProps, InterviewsPageState> {
    constructor(props: InterviewsPageProps) {
        super(props);
        this.state = {
            uid: "",
            user: null,
            accountType: null,
            companyInfo: null,
            interviews: null,
            interviewsData: null
        };
        this.addInterview = this.addInterview.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount = (): void => {
        const auth = getAuth();
        setPersistence(auth, browserLocalPersistence)
            .then(() => {
                onAuthStateChanged(auth, async (user: User | null) => {
                    if (user) {
                        try {
                            const dbRef = ref(getDatabase());
                            const snapshot = await get(child(dbRef, `users/${user.uid}`));
                            let accountType = 'job_seeker';
                            let companyInfo = null;

                            if (snapshot.exists()) {
                                const userData = snapshot.val();
                                accountType = userData.accountType || 'job_seeker';
                                if (accountType === 'company') {
                                    companyInfo = userData;
                                }
                            }

                            this.setState({
                                uid: user.uid,
                                user: user,
                                accountType: accountType as "job_seeker" | "company",
                                companyInfo: companyInfo
                            });
                            this.loadInterviews(user.uid);
                        } catch (error) {
                            console.error('Error loading user data:', error);
                            this.setState({
                                uid: user.uid,
                                user: user,
                                accountType: 'job_seeker'
                            });
                            this.loadInterviews(user.uid);
                        }
                    } else {
                        this.props.history.push("/login");
                    }
                });
            }).catch((error) => {
                console.log(error);
            });
    }

    loadInterviews = (uid: string): void => {
        const dbRef = ref(getDatabase());
        get(child(dbRef, `interviews/${uid}`)).then((snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                this.setState({
                    interviews: Object.keys(data),
                    interviewsData: { [uid]: data }
                });
            } else {
                console.log("No data available.");
            }
        }).catch((error) => {
            console.error(error);
        });
    }

    addInterview = (): void => {
        console.log("add interview");
        const dbRef = ref(getDatabase());
        const key = rand.generate(6);
        const uid = this.state.uid;

        if (!uid) {
            console.error("No user ID available");
            return;
        }

        const interviewData: InterviewSessionData = {
            content: '# Welcome to your Interview Sandbox! \n\n# 1 - Just share this link with another person \n# \t  to get them on the same page.\n# 2 - Once they join, you\'ll see the call button.\n# 3 - The code, code output, and drawings are synced\n#     in real time between users.\n# 4 - Select between Javascript, Python, Ruby, Swift,\n#     Java, Go, Kotlin, PHP, R, and Scala.\n\n# Try running the code below to see the ouput!\n\nprint("hello world")',
            createdon: new Date().toLocaleString(),
        };

        set(child(dbRef, `interviews/${uid}/${key}`), interviewData)
            .then(() => {
                // Reload interviews after adding new one
                this.loadInterviews(uid);
            })
            .catch((error) => {
                console.error("Error adding interview:", error);
            });
    }

    logout = async (): Promise<void> => {
        try {
            await getAuth().signOut();
            this.props.history.push('/login');
        } catch (error) {
            console.error('Logout failed', error);
        }
    }

    renderInterviews = (): React.ReactElement[] | null => {
        const { interviews, interviewsData, uid } = this.state;

        if (interviews && interviewsData && uid && interviewsData[uid]) {
            return Object.keys(interviewsData[uid]).map((interviewId) => {
                return (
                    <div key={interviewId} className="listBorder">
                        <Link to={`/interviews/${interviewId}`} className="link">
                            interviewsandbox.com/interviews/{interviewId}
                        </Link>
                        <div className="list">
                            {interviewsData[uid][interviewId].createdon}
                        </div>
                    </div>
                );
            });
        }
        return null;
    }

    render(): React.ReactElement {
        return (
            <div className="interviews-content">
                <div className="interviews-title-row">
                    <h3 className="interviews">Interviews</h3>
                    <div className="addBtn" onClick={this.addInterview}>
                        <IconContext.Provider value={{
                            size: "1.5em",
                            style: {
                                paddingRight: "0.2rem",
                                marginTop: "0.1rem"
                            }
                        }}>
                            <GrAdd />
                        </IconContext.Provider>
                    </div>
                </div>

                <div className="listTop">
                    {this.renderInterviews()}
                </div>
            </div>
        );
    }
}
